import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { Features20Content } from "types/graphql/generated";

interface Props {
  content: Features20Content;
}

const Features20: VFC<Props> = withErrorBoundary(({ content: { sideTitle, title, description } }) => {
  useAnchor("features20");

  return (
    <StyledFeatures20 className="features20 Content">
      <h3 className="Features20__sideTitle Font_24_32_600">{sideTitle}</h3>
      <div className="Features20__mainContent ">
        <Markdown className="Font_32_40_600">{title}</Markdown>
        <Markdown className="Features20__description Color_secondary Font_18_26_450">{description}</Markdown>
      </div>
    </StyledFeatures20>
  );
}, {});

const StyledFeatures20 = styled.section`
  display: flex;
  margin-top: -64px;
  padding-top: 64px;

  .Features20__sideTitle {
    flex-shrink: 0;
    width: 200px;
    margin-top: 7px;
  }

  .Features20__mainContent {
    max-width: 704px;
    margin-left: 72px;
  }

  .Features20__description {
    margin-top: 24px;

    p:not(:first-child) {
      margin-top: 16px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .Features20__mainContent {
      max-width: 626px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    flex-direction: column;

    .Features20__sideTitle {
      margin-top: 0;
    }

    .Features20__mainContent {
      margin-left: 0;
      margin-top: 32px;
    }

    .Features20__description {
      margin-top: 16px;
    }
  }
`;

gql`
  fragment Features20Content on ComponentFeaturesFeatures20 {
    sideTitle
    title
    description
  }
`;

export { Features20 };
export type { Props as Features20Props };
